var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{style:(_vm.style)},[_c('view-header'),_c('router-view'),_c('viewFoot')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }